import {Injectable} from "@angular/core";
import {HandlerError, HttpErrorHandlerService} from "../../../core/services/http-error-handler.service";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {catchError, Observable} from "rxjs";
import {BaseResponse} from "../../../core/models/base-response";
import {ListaEmpresa} from "../models/lista-empresa";

@Injectable({
  providedIn: 'root'
})
export class EmpresaService{
  private handlerErro: HandlerError;

  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandlerService) {
    this.handlerErro = httpErrorHandler.createHandleError(`DashboardService`);
  }

  baseUrl = environment.apiUrl;

  listar(): Observable<BaseResponse<ListaEmpresa> | BaseResponse<any>> {
    return this.http
      .get<BaseResponse<ListaEmpresa>>(`${this.baseUrl}/Empresa`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('listar')));
  }

}
